/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import MaterialTable from 'material-table';
import useQuickBook from '../../../../hooks/useQuickBook';
import usePractice from '../../../../hooks/usePractice';
import useImport from '../../../../hooks/useImport';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
/* CSS */
import useStyles from '../../Main.style';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Slide,
  Checkbox,
  TextField,
  Box,
  Grid,
  Typography,
} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {
  formatToCurrencyDash,
  getLoggedInUserData,
  toProperCase,
  customSortHelper1,
  addLoader,
} from '../../../../utils/Helper';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover';

const CollectionReportAll = ({ dashboardComments, onCommentUpdate }) => {
  const classes = useStyles();
  const loggedInUserData = getLoggedInUserData();

  // Helper function to sort data by Overall Outstanding in descending order
  const sortDataByOverallOutstanding = (data) => {
    if (!data || data.length === 0) return data;

    return [...data].sort((a, b) => {
      return customSortHelper1(b, a, 'overalloutstanding'); // Reverse order for descending
    });
  };
  const { getCountry, getCountriesCells } = usePractice();
  const { getSelectedCellsReportDataForDisplay } = useImport();
  const [pastDueTableObject, setPastDueTableObject] = useState([]);
  const [isDataFromImport, setIsDataFromImport] = React.useState(false);
  const [collectionReportLoader, setCollectionReportLoader] = React.useState(false);
  const [totalOverallOutstandingBalance, setTotalOverallOutstandingBalance] = React.useState(0);
  const [totalPastDueBalance, setTotalPastDueBalance] = React.useState(0);
  const [totalAccountReceivables, seTtotalAccountReceivables] = React.useState(0);
  const { pastDueTableByCountry, pastDueTableByCell } = useQuickBook();
  const [openFilter, setOpenFilter] = React.useState(false);
  const SelectAllCountries = { countryTitle: 'Select All' };
  const [countryList, setCountryList] = useState([]);
  const [openCountry, setOpenCountry] = useState(false);
  const [show, setShow] = useState(true);
  const SelectAllCells = { cellTitle: 'Select All' };
  const [cellListForFilter, setCellListForFilter] = useState([]);
  const [selectedCellOption, setSelectedCellOption] = useState(
    loggedInUserData?.cellId
      ? [{ cellId: loggedInUserData.cellId, cellTitle: loggedInUserData.cell.cellTitle }]
      : [],
  );
  const [selectedCountryOption, setSelectedCountryOption] = useState(
    loggedInUserData?.countryId
      ? [
          {
            countryId: loggedInUserData?.countryId,
            countryTitle: loggedInUserData?.country?.countryTitle,
          },
        ]
      : [],
  );
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [isApplyClicked, setIsApplyClicked] = useState(false);
  const [openCountryClick, setOpenCountryClick] = React.useState(false);
  const [currentFpPage] = useState(1);
  const [pageFpSize] = useState(50);
  const startFpIndex = (currentFpPage - 1) * pageFpSize;
  const endFpIndex = startFpIndex + pageFpSize;
  const [displayedTcData, setDisplayedTcData] = React.useState([]);
  const [collectionDataFromImport, setCollectionDataFromImport] = useState([]);
  const [selectedCells, setSelectedCells] = useState(null);
  const [disable, setDisable] = useState(true);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleColumnClick = () => {
    // Update the state to track the clicked column
    setShow(!show); // Toggle the show state
  };

  const handleToggleOpen = (source) => {
    if (source == 'open') {
      setOpenCountry(true);
    } else if (source == 'close') {
      setOpenCountry(false);
    } else if ('changeEvent') {
      setOpenCountry(true);
    }
  };

  const loadCountries = async () => {
    setDisable(true);
    const countryLists = await getCountry();
    if (countryLists.usersResult) {
      setCountryList(countryLists.usersResult);
    }
    setDisable(false);
  };

  const removeButtonSelection = () => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    buttons.forEach((button) => {
      const parentDiv = button.parentElement;
      parentDiv.classList.add(classes.TableInnerFilter);
      parentDiv.classList.remove(classes.TableInnerFilterSelect);
    });
  };

  const loadCellsForFilter = async (countryIdList) => {
    if (countryIdList.length > 0) {
      const CellList = await getCountriesCells(countryIdList);
      setCellListForFilter(CellList?.usersResult);
      setSelectedCellOption(CellList?.usersResult);
      return CellList.usersResult;
    } else {
      setCellListForFilter([]);
      return [];
    }
  };

  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };

  const fillPastDueTotals = async (reportObj) => {
    const tableData = [];
    const columnTotal = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let columnTotalObj = 0;

    reportObj?.Rows?.Row.sort((ad, bd) => {
      const adVal =
        ad?.ColData &&
        Number(ad?.ColData[2]?.value) +
          Number(ad?.ColData[3]?.value) +
          Number(ad?.ColData[4]?.value) +
          Number(ad?.ColData[5]?.value) +
          Number(ad?.ColData[6]?.value) +
          Number(ad?.ColData[7]?.value);
      const bdVal =
        bd?.ColData &&
        Number(bd?.ColData[2]?.value) +
          Number(bd?.ColData[3]?.value) +
          Number(bd?.ColData[4]?.value) +
          Number(bd?.ColData[5]?.value) +
          Number(bd?.ColData[6]?.value) +
          Number(bd?.ColData[7]?.value);

      if (adVal && bdVal) {
        return bdVal - adVal;
      } else if (adVal) {
        return -1;
      } else if (bdVal) {
        return 1;
      } else {
        return 0;
      }
    }).map((c, index) => {
      if (c?.ColData) {
        if (index <= endFpIndex) {
          columnTotal[0] += parseFloat(
            c?.ColData[2]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[2]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || 0,
          );
          columnTotal[1] += parseFloat(
            c?.ColData[1]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[1]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[2] += parseFloat(
            c?.ColData[3]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[3]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[3] += parseFloat(
            c?.ColData[4]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[4]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[4] += parseFloat(
            c?.ColData[5]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[5]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[5] += parseFloat(
            c?.ColData[6]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[6]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[6] += parseFloat(
            c?.ColData[7]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[7]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[7] += parseFloat(
            c?.ColData[8]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[8]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          (columnTotal[8] =
            columnTotal[0] +
            columnTotal[2] +
            columnTotal[3] +
            columnTotal[4] +
            columnTotal[5] +
            columnTotal[6] +
            columnTotal[7]),
            (columnTotal[9] += parseFloat(
              c?.ColData[9]?.value === ''
                ? (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : parseFloat(c?.ColData[9]?.value).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) ||
                    (0).toFixed(2).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }),
            ));
          columnTotal[10] +=
            c?.ColData[1]?.value === '' ? 0 : parseFloat(c?.ColData[1]?.value || 0);
        }

        const tableRowObj = {
          client: c?.ColData[0]?.value,
          current: c?.ColData[1]?.value,
          zerotofifteendays: c?.ColData[2]?.value,
          sixteentothirtydays: c?.ColData[3]?.value,
          thirtyonetofortyfivedays: c?.ColData[4]?.value,
          fortysixtosixtydays: c?.ColData[5]?.value,
          sixtyonetoseventyfivedays: c?.ColData[6]?.value,
          seventysixtonintydays: c?.ColData[7]?.value,
          morethannintyonedays: c?.ColData[8]?.value,
          pastduebalance:
            parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
            parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
            parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
            parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
            parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
            parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
            parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value),

          overalloutstanding: (c?.ColData[9]?.value, classes),
        };

        if (pageFpSize * currentFpPage < reportObj?.Rows?.Row?.length && index == endFpIndex - 1) {
          columnTotalObj = {
            client: 'Total',
            current: columnTotal[1],
            zerotofifteendays: columnTotal[0],
            sixteentothirtydays: columnTotal[2],
            thirtyonetofortyfivedays: columnTotal[3],
            fortysixtosixtydays: columnTotal[4],
            sixtyonetoseventyfivedays: columnTotal[5],
            seventysixtonintydays: columnTotal[6],
            morethannintyonedays: columnTotal[7],
            pastduebalance: columnTotal[8],
            overalloutstanding: columnTotal[9],
          };

          tableData.push(columnTotalObj);
          tableData.push(tableRowObj);
        } else if (index == reportObj?.Rows?.Row?.length - 2) {
          columnTotalObj = {
            client: 'Total',
            current: columnTotal[1],
            zerotofifteendays: columnTotal[0],
            sixteentothirtydays: columnTotal[2],
            thirtyonetofortyfivedays: columnTotal[3],
            fortysixtosixtydays: columnTotal[4],
            sixtyonetoseventyfivedays: columnTotal[5],
            seventysixtonintydays: columnTotal[6],
            morethannintyonedays: columnTotal[7],
            pastduebalance: columnTotal[8],
            overalloutstanding: columnTotal[9],
          };
          tableData.push(tableRowObj);
          tableData.push(columnTotalObj);
        } else {
          tableData.push(tableRowObj);
        }

        parseFloat(c?.ColData[1]?.value == '' ? 0 : parseFloat(c?.ColData[1]?.value));
      }
    });

    const tableObject = {
      columns: reportObj?.Columns?.Column,
      rows: tableData,
      pastDueBalance: columnTotal[8],
      accountReceivable: columnTotal[1],
      overallOutstandingBalance: columnTotalObj?.overalloutstanding,
    };
    if (collectionDataFromImport?.length > 0) {
      setPastDueTableObject([]);
    } else {
      setPastDueTableObject(tableObject);
    }
  };

  const loadPastDueTableByCountry = async () => {
    setCollectionReportLoader(true);
    const pastDueTableArr = await pastDueTableByCountry({ countryId: loggedInUserData?.countryId });
    fillPastDueTotals(pastDueTableArr?.reportResult);
    setSelectedCountryOption(countryList);
    const defaultCells = await loadCellsForFilter(countryList);
    setSelectedCellOption(defaultCells);
    setCollectionReportLoader(false);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const loadCollectionDataFromImportForSelectedCell = async (values) => {
    setCollectionReportLoader(true);
    const result = await getSelectedCellsReportDataForDisplay({ cellValues: values });
    setIsDataFromImport(result?.fromImport);
    setTotalOverallOutstandingBalance(result?.totalOverallOutstandingBalance);
    setTotalPastDueBalance(result?.totalPastDueBalance);
    seTtotalAccountReceivables(result?.totalPastDueBalance);
    if (result?.crResult && result?.crResult.length > 0) {
      createCollectionDataFromImport(result?.crResult);
      setCollectionReportLoader(false);
      return true;
    } else {
      setCollectionDataFromImport([]);
      setCollectionReportLoader(false);
      return false;
    }
  };

  const createCollectionDataFromImport = (data) => {
    const importedDataArray = [];
    const totals = {
      currentAmount: 0,
      past1to15: 0,
      past16to30: 0,
      past31to45: 0,
      past46to60: 0,
      past61to75: 0,
      past76to90: 0,
      past91: 0,
    };
    let fileterdData = [];

    const selectedCellIds = selectedCells?.split(',');
    if (selectedCellIds?.length > 0) {
      fileterdData = data.filter((item) => selectedCellIds.includes(item?.cellId.toString()));
    } else {
      fileterdData = data;
    }

    fileterdData?.forEach((item, index) => {
      const pastDueBalance =
        parseFloat(item?.past1to15 || 0) +
        parseFloat(item?.past16to30 || 0) +
        parseFloat(item?.past31to45 || 0) +
        parseFloat(item?.past46to60 || 0) +
        parseFloat(item?.past61to75 || 0) +
        parseFloat(item?.past76to90 || 0) +
        parseFloat(item?.past91 || 0);

      const overallOutstanding = parseFloat(item.currentAmount) + pastDueBalance;

      importedDataArray.push({
        client: item?.clientName,
        current: item?.currentAmount,
        zerotofifteendays: item?.past1to15,
        sixteentothirtydays: item?.past16to30,
        thirtyonetofortyfivedays: item?.past31to45,
        fortysixtosixtydays: item?.past46to60,
        sixtyonetoseventyfivedays: item?.past61to75,
        seventysixtonintydays: item?.past76to90,
        morethannintyonedays: item?.past91,
        pastduebalance: pastDueBalance,
        overalloutstanding: overallOutstanding,
        tableData: { id: index },
        cellId: item?.cellId,
      });

      // Update totals
      totals.currentAmount += parseFloat(item?.currentAmount || 0);
      totals.past1to15 += parseFloat(item?.past1to15 || 0);
      totals.past16to30 += parseFloat(item?.past16to30 || 0);
      totals.past31to45 += parseFloat(item?.past31to45 || 0);
      totals.past46to60 += parseFloat(item?.past46to60 || 0);
      totals.past61to75 += parseFloat(item?.past61to75 || 0);
      totals.past76to90 += parseFloat(item?.past76to90 || 0);
      totals.past91 += parseFloat(item?.past91 || 0);
    });

    // Add totals row
    importedDataArray.push({
      client: 'Total',
      current: totals?.currentAmount || 0,
      zerotofifteendays: totals?.past1to15 || 0,
      sixteentothirtydays: totals?.past16to30 || 0,
      thirtyonetofortyfivedays: totals?.past31to45 || 0,
      fortysixtosixtydays: totals?.past46to60 || 0,
      sixtyonetoseventyfivedays: totals?.past61to75 || 0,
      seventysixtonintydays: totals?.past76to90 || 0,
      morethannintyonedays: totals?.past91 || 0,
      pastduebalance:
        totals.past1to15 +
        totals.past16to30 +
        totals.past31to45 +
        totals.past46to60 +
        totals.past61to75 +
        totals.past76to90 +
        totals.past91,
      overalloutstanding:
        totals.currentAmount +
        totals.past1to15 +
        totals.past16to30 +
        totals.past31to45 +
        totals.past46to60 +
        totals.past61to75 +
        totals.past76to90 +
        totals.past91,
      tableData: { id: data?.length },
    });
    setPastDueTableObject({});
    setPastDueTableObject({
      accountReceivable: formatToCurrencyDash(
        totals.past1to15 +
          totals.past16to30 +
          totals.past31to45 +
          totals.past46to60 +
          totals.past61to75 +
          totals.past76to90 +
          totals.past91,
      ),
      pastDueBalance: formatToCurrencyDash(
        totals.currentAmount +
          totals.past1to15 +
          totals.past16to30 +
          totals.past31to45 +
          totals.past46to60 +
          totals.past61to75 +
          totals.past76to90 +
          totals.past91,
      ),
      overallOutstandingBalance:
        totals.past1to15 +
        totals.past16to30 +
        totals.past31to45 +
        totals.past46to60 +
        totals.past61to75 +
        totals.past76to90 +
        totals.past91,
    });

    setDisplayedTcData([]);
    setDisplayedTcData(sortDataByOverallOutstanding(importedDataArray));
    setCollectionDataFromImport(importedDataArray);
  };

  useEffect(() => {
    setCollectionReportLoader(true);
    const initializeFilters = async () => {
      if (loggedInUserData?.countryId) {
        const defaultCountry = {
          ...loggedInUserData.country,
          id: loggedInUserData.countryId,
          countryTitle: loggedInUserData.country.countryTitle,
        };

        const defaultCell = {
          cellId: loggedInUserData.cellId,
          cellTitle: loggedInUserData.cell.cellTitle,
          ...loggedInUserData.cell,
        };

        // Load cells for the selected country
        const cells = await loadCellsForFilter([defaultCountry]);
        // Find the default cell in the loaded cells
        const filteredCell = cells.find((cell) => cell.cellId === loggedInUserData.cellId);

        // Use filteredCell or defaultCell directly instead of selectedCellOption
        const selectedCellsForDataFetch = filteredCell ? [filteredCell] : [defaultCell];
        // Load data for the selected cells
        const data = await loadCollectionDataFromImportForSelectedCell(selectedCellsForDataFetch);

        if (!data) {
          // If no data is returned, handle the fallback
          setCollectionDataFromImport([]);

          const cellIds = selectedCellsForDataFetch
            .filter((item) => item.qbId !== null && item.qbId !== undefined)
            .map((item) => item.qbId)
            .join(',');
          const pastDueTableArr = await pastDueTableByCell({
            cellId: cellIds,
          });

          fillPastDueTotals(pastDueTableArr?.reportResult ? pastDueTableArr?.reportResult : []);

          if (selectedCellsForDataFetch?.length > 0) {
            setSelectedCellOption(selectedCellsForDataFetch);
          } else {
            setSelectedCellOption([]);
          }
        }
      }
    };

    initializeFilters();
    setCollectionReportLoader(false);
  }, []); // Only runs once on mount with loggedInUserData

  useEffect(() => {
    setCollectionReportLoader(true);
    if (collectionDataFromImport?.length > 0) {
      !isApplyClicked &&
        setDisplayedTcData(
          sortDataByOverallOutstanding(collectionDataFromImport?.slice(startFpIndex, endFpIndex)),
        );
    } else {
      if (Object.keys(pastDueTableObject).length > 0) {
        setDisplayedTcData(
          sortDataByOverallOutstanding(pastDueTableObject?.rows?.slice(startFpIndex, endFpIndex)),
        );
      }
    }
    setCollectionReportLoader(false);
  }, [pastDueTableObject, startFpIndex, endFpIndex, currentFpPage, isApplyClicked]);

  useEffect(() => {
    setCollectionReportLoader(true);
    loadCountries();
    setCollectionReportLoader(false);
  }, []);

  useEffect(() => {
    setCollectionReportLoader(true);
    function handleClickOutside(event) {
      if (
        !event.target.closest('#countryAutoComplete') &&
        !event.target.closest('#country-popup') &&
        !event.target.closest('#countryAutoCompleteMob')
      ) {
        setOpenCountry(false);
        setOpenCountryClick(false);
      }
      if (event.target.closest('#countryAutoComplete')) {
        if (openCountry) {
          setOpenCountryClick(true);
        }

        if (openCountryClick && openCountry) {
          setOpenCountryClick(false);
          setOpenCountry(false);
        }
      }
    }

    // Attach the event listener on component mount
    window.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    setCollectionReportLoader(false);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [openCountryClick, openCountry]);

  return (
    <Box p={2}>
      {/* Total collection COMPONENT */}

      <Grid container style={{ height: '100%' }}>
        <Grid item xs={12}>
          <Grid container direction="row">
            <Grid container>
              <Formik
                enableReinitialize={false}
                initialValues={{
                  countryid: [],
                  cellid: [],
                }}
              >
                {({ isSubmitting, setFieldValue, resetForm }) => {
                  return (
                    <>
                      <Box mt={2}>
                        <Grid container direction="row">
                          <Grid item xs={12} className={classes.FilterButtonMobile}>
                            <Box>
                              <Button
                                startIcon={<FilterListIcon />}
                                color="primary"
                                onClick={handleClickOpenFilter}
                              >
                                Filters
                              </Button>
                              <If condition={openFilter}>
                                <Dialog
                                  fullScreen
                                  open={openFilter}
                                  onClose={handleCloseFilter}
                                  TransitionComponent={Transition}
                                >
                                  <DialogTitle id="simple-dialog-title">
                                    <Box display="flex" justifyContent="space-between">
                                      <Box
                                        onClick={async () => {
                                          resetForm();
                                          setSelectedCells(null);
                                          setSelectedCountryOption([]);
                                          setSelectedCellOption([]);

                                          // Clear all table data immediately
                                          setPastDueTableObject([]);
                                          setCollectionDataFromImport([]);
                                          setDisplayedTcData([]);
                                          setIsDataFromImport(false);
                                          setTotalOverallOutstandingBalance(0);
                                          setTotalPastDueBalance(0);
                                          seTtotalAccountReceivables(0);

                                          const data = await loadCollectionDataFromImportForSelectedCell(
                                            [],
                                          );
                                          if (!data) {
                                            loadPastDueTableByCountry();
                                          }
                                          removeButtonSelection();
                                        }}
                                      >
                                        Clear All
                                      </Box>
                                      <Box>
                                        <b>Filters</b>
                                      </Box>
                                      <Box onClick={handleCloseFilter}>Cancel</Box>
                                    </Box>
                                  </DialogTitle>
                                  <DialogContent>
                                    <Grid container spacing={2}>
                                      <Grid
                                        item
                                        xs={12}
                                        className={classes.FilterDropdownWidthSelectMob}
                                      >
                                        <div id="countryAutoCompleteMob">
                                          <Autocomplete
                                            multiple
                                            id="country-mob"
                                            disabled={disable}
                                            disableCloseOnSelect
                                            options={[SelectAllCountries, ...countryList]}
                                            getOptionLabel={(option) => {
                                              return option?.countryTitle;
                                            }}
                                            onChange={(event, newValue) => {
                                              newValue?.length === 0 &&
                                                setSelectedCountryOption(newValue);
                                            }}
                                            renderTags={() => {}}
                                            renderOption={(option) => (
                                              <React.Fragment>
                                                {option === SelectAllCountries ? (
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={
                                                          selectedCountryOption?.length ===
                                                          countryList?.length
                                                        }
                                                      />
                                                    }
                                                    label={option.countryTitle}
                                                    onChange={(event) => {
                                                      if (event.target.checked) {
                                                        setSelectedCountryOption(countryList);
                                                        setFieldValue(
                                                          'countryid',
                                                          countryList || [],
                                                        );
                                                        loadCellsForFilter(
                                                          selectedCountryOption || [],
                                                        );
                                                      } else {
                                                        setFieldValue('countryid', []);
                                                        setSelectedCountryOption([]);
                                                        loadCellsForFilter(
                                                          selectedCountryOption || [],
                                                        );
                                                      }
                                                    }}
                                                  />
                                                ) : (
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selectedCountryOption.some(
                                                          (selectedOption) =>
                                                            selectedOption.countryTitle ===
                                                            option.countryTitle,
                                                        )}
                                                        onChange={() => {
                                                          setIsApplyClicked(false);
                                                          const isSelected = selectedCountryOption.some(
                                                            (selectedOption) =>
                                                              selectedOption.countryTitle ===
                                                              option.countryTitle,
                                                          );

                                                          let newSelectedOptions = [];

                                                          if (isSelected) {
                                                            newSelectedOptions = selectedCountryOption.filter(
                                                              (selectedOption) =>
                                                                selectedOption.countryTitle !==
                                                                option.countryTitle,
                                                            );
                                                          } else {
                                                            newSelectedOptions = [
                                                              ...selectedCountryOption,
                                                              option,
                                                            ];
                                                          }

                                                          setSelectedCountryOption(
                                                            newSelectedOptions,
                                                          );
                                                          setFieldValue(
                                                            'countryid',
                                                            newSelectedOptions || [],
                                                          );
                                                          loadCellsForFilter(
                                                            newSelectedOptions || [],
                                                          );
                                                        }}
                                                      />
                                                    }
                                                    label={option.countryTitle}
                                                  />
                                                )}
                                              </React.Fragment>
                                            )}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                name="countryid"
                                                variant="outlined"
                                                placeholder={
                                                  selectedCountryOption?.length > 1 &&
                                                  selectedCountryOption?.length <=
                                                    countryList?.length
                                                    ? 'Multiple Countries'
                                                    : selectedCountryOption?.length == 1
                                                    ? selectedCountryOption[0].countryTitle
                                                    : 'Select Country'
                                                }
                                              />
                                            )}
                                            popupIcon={<ExpandMoreIcon />}
                                          />
                                        </div>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        className={classes.FilterDropdownWidthSelectMob}
                                      >
                                        <Autocomplete
                                          multiple
                                          id="cells-mob"
                                          disabled={disable}
                                          disableCloseOnSelect
                                          options={[SelectAllCells, ...cellListForFilter]}
                                          getOptionLabel={(option) => {
                                            return option?.countryDetails?.countryTitle
                                              ? option?.countryDetails?.countryTitle + ' - '
                                              : '' + option?.cellTitle;
                                          }}
                                          onChange={(event, newValue) => {
                                            newValue?.length === 0 &&
                                              setSelectedCellOption(newValue);
                                          }}
                                          renderTags={() => {}}
                                          renderOption={(option) => (
                                            <React.Fragment>
                                              {option === SelectAllCells ? (
                                                <FormControlLabel
                                                  control={
                                                    <Checkbox
                                                      icon={icon}
                                                      checkedIcon={checkedIcon}
                                                      style={{ marginRight: 8 }}
                                                      checked={
                                                        selectedCellOption?.length ===
                                                        cellListForFilter?.length
                                                      }
                                                    />
                                                  }
                                                  label={
                                                    option?.countryDetails?.countryTitle
                                                      ? option?.countryDetails?.countryTitle + ' - '
                                                      : '' + option?.cellTitle
                                                  }
                                                  onChange={(event) => {
                                                    if (event.target.checked) {
                                                      setSelectedCellOption(cellListForFilter);
                                                      setFieldValue(
                                                        'cellid',
                                                        cellListForFilter || [],
                                                      );
                                                    } else {
                                                      setFieldValue('cellid', []);
                                                      setSelectedCellOption([]);
                                                    }
                                                  }}
                                                />
                                              ) : (
                                                <FormControlLabel
                                                  control={
                                                    <Checkbox
                                                      icon={icon}
                                                      checkedIcon={checkedIcon}
                                                      style={{ marginRight: 8 }}
                                                      checked={selectedCellOption.some(
                                                        (selectedOption) =>
                                                          selectedOption.cellTitle ===
                                                          option.cellTitle,
                                                      )}
                                                      onChange={() => {
                                                        setIsApplyClicked(false);
                                                        const isSelected = selectedCellOption.some(
                                                          (selectedOption) =>
                                                            selectedOption.cellTitle ===
                                                            option.cellTitle,
                                                        );

                                                        let newSelectedOptions = [];

                                                        if (isSelected) {
                                                          newSelectedOptions = selectedCellOption.filter(
                                                            (selectedOption) =>
                                                              selectedOption.cellTitle !==
                                                              option.cellTitle,
                                                          );
                                                        } else {
                                                          newSelectedOptions = [
                                                            ...selectedCellOption,
                                                            option,
                                                          ];
                                                        }

                                                        setSelectedCellOption(newSelectedOptions);
                                                        setFieldValue(
                                                          'cellid',
                                                          newSelectedOptions || [],
                                                        );
                                                      }}
                                                    />
                                                  }
                                                  label={
                                                    option?.countryDetails?.countryTitle
                                                      ? option?.countryDetails?.countryTitle + ' - '
                                                      : '' + option?.cellTitle
                                                  }
                                                />
                                              )}
                                            </React.Fragment>
                                          )}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              name="cellid"
                                              variant="outlined"
                                              placeholder={
                                                selectedCellOption?.length > 1 &&
                                                selectedCellOption?.length <=
                                                  cellListForFilter?.length
                                                  ? 'Multiple Cells'
                                                  : selectedCellOption?.length == 1
                                                  ? selectedCellOption[0].cellTitle
                                                  : 'Select Cell'
                                              }
                                            />
                                          )}
                                          popupIcon={<ExpandMoreIcon />}
                                        />
                                      </Grid>
                                    </Grid>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      color="primary"
                                      onClick={async () => {
                                        setIsApplyClicked(true);
                                        setOpenFilter(false);
                                        const response = await loadCollectionDataFromImportForSelectedCell(
                                          selectedCellOption,
                                        );

                                        if (response) {
                                          const cellIds = selectedCellOption
                                            .filter(
                                              (item) => item.id !== null && item.id !== undefined,
                                            )
                                            .map((item) => item.id)
                                            .join(',');
                                          setSelectedCells(cellIds);
                                        } else {
                                          setCollectionDataFromImport([]);
                                          const cellIds = selectedCellOption
                                            .filter(
                                              (item) =>
                                                item.qbId !== null && item.qbId !== undefined,
                                            )
                                            .map((item) => item.qbId)
                                            .join(',');
                                          const pastDueTableArr = await pastDueTableByCell({
                                            cellId: cellIds,
                                          });
                                          fillPastDueTotals(pastDueTableArr?.reportResult);
                                        }
                                      }}
                                      fullWidth
                                    >
                                      Apply
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </If>
                            </Box>
                          </Grid>
                          <Grid item xs={12} className={classes.FilterDesktop}>
                            <Grid container spacing={2} className={classes.AutoCompleteDisable}>
                              <Grid item className={classes.FilterDropdownWidthSelect}>
                                <div id="countryAutoComplete">
                                  <Autocomplete
                                    multiple
                                    id="country"
                                    open={openCountry}
                                    disabled={disable}
                                    onOpen={() => handleToggleOpen('open')}
                                    disableCloseOnSelect
                                    options={[SelectAllCountries, ...countryList]}
                                    getOptionLabel={(option) => {
                                      return option?.countryTitle;
                                    }}
                                    onChange={(event, newValue) => {
                                      handleToggleOpen('changeEvent');
                                      newValue?.length === 0 && setSelectedCountryOption(newValue);
                                    }}
                                    renderTags={() => {}}
                                    renderOption={(option) => (
                                      <React.Fragment>
                                        {option === SelectAllCountries ? (
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={
                                                  selectedCountryOption?.length ===
                                                  countryList?.length
                                                }
                                              />
                                            }
                                            label={option.countryTitle}
                                            onChange={async (event) => {
                                              setIsApplyClicked(false);
                                              if (event.target.checked) {
                                                setSelectedCountryOption(countryList);
                                                setFieldValue('countryid', countryList || []);
                                                loadCellsForFilter(countryList || []);
                                              } else {
                                                setFieldValue('countryid', []);
                                                setSelectedCountryOption([]);
                                                setSelectedCellOption(await loadCellsForFilter([]));
                                              }
                                            }}
                                          />
                                        ) : (
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selectedCountryOption.some(
                                                  (selectedOption) =>
                                                    selectedOption.countryTitle ===
                                                    option.countryTitle,
                                                )}
                                                onChange={() => {
                                                  setIsApplyClicked(false);
                                                  const isSelected = selectedCountryOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.countryTitle ===
                                                      option.countryTitle,
                                                  );

                                                  let newSelectedOptions = [];

                                                  if (isSelected) {
                                                    newSelectedOptions = selectedCountryOption.filter(
                                                      (selectedOption) =>
                                                        selectedOption.countryTitle !==
                                                        option.countryTitle,
                                                    );
                                                  } else {
                                                    newSelectedOptions = [
                                                      ...selectedCountryOption,
                                                      option,
                                                    ];
                                                  }

                                                  setSelectedCountryOption(newSelectedOptions);
                                                  setFieldValue(
                                                    'countryid',
                                                    newSelectedOptions || [],
                                                  );
                                                  loadCellsForFilter(newSelectedOptions || []);
                                                  setOpenCountry(true);
                                                }}
                                              />
                                            }
                                            label={
                                              <Typography onClick={(e) => e.stopPropagation()}>
                                                {option.countryTitle}
                                              </Typography>
                                            }
                                          />
                                        )}
                                      </React.Fragment>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        name="countryid"
                                        variant="outlined"
                                        placeholder={
                                          selectedCountryOption.length > 1 &&
                                          selectedCountryOption.length <= countryList.length
                                            ? 'Multiple Countries'
                                            : selectedCountryOption.length == 1
                                            ? selectedCountryOption[0].countryTitle
                                            : 'Select Country'
                                        }
                                      />
                                    )}
                                    popupIcon={<ExpandMoreIcon />}
                                  />
                                </div>
                              </Grid>

                              <Grid item className={classes.FilterDropdownWidthSelect}>
                                <Autocomplete
                                  multiple
                                  id="cells"
                                  disabled={disable}
                                  disableCloseOnSelect
                                  options={
                                    cellListForFilter && cellListForFilter.length > 0
                                      ? [SelectAllCells, ...cellListForFilter]
                                      : []
                                  }
                                  getOptionLabel={(option) => {
                                    return option?.countryDetails?.countryTitle
                                      ? option?.countryDetails?.countryTitle + ' - '
                                      : '' + option?.cellTitle;
                                  }}
                                  onChange={(event, newValue) => {
                                    newValue.length === 0 && setSelectedCellOption(newValue);
                                  }}
                                  renderTags={() => {}}
                                  renderOption={(option) => (
                                    <React.Fragment>
                                      {option === SelectAllCells ? (
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={
                                                selectedCellOption.length ===
                                                cellListForFilter.length
                                              }
                                            />
                                          }
                                          label={
                                            option?.countryDetails?.countryTitle
                                              ? option?.countryDetails?.countryTitle + ' - '
                                              : '' + option?.cellTitle
                                          }
                                          onChange={(event) => {
                                            if (event.target.checked) {
                                              setSelectedCellOption(cellListForFilter);
                                              setFieldValue('cellid', cellListForFilter || []);
                                            } else {
                                              setFieldValue('cellid', []);
                                              setSelectedCellOption([]);
                                            }
                                          }}
                                        />
                                      ) : (
                                        <>
                                          {' '}
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={
                                                  selectedCellOption.length ===
                                                  cellListForFilter.length
                                                    ? true
                                                    : selectedCellOption.some(
                                                        (selectedOption) =>
                                                          selectedOption.cellTitle ===
                                                          option.cellTitle,
                                                      )
                                                }
                                                onChange={() => {
                                                  setIsApplyClicked(false);
                                                  const isSelected = selectedCellOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.cellTitle === option.cellTitle,
                                                  );

                                                  let newSelectedOptions = [];

                                                  if (isSelected) {
                                                    newSelectedOptions = selectedCellOption.filter(
                                                      (selectedOption) =>
                                                        selectedOption.cellTitle !==
                                                        option.cellTitle,
                                                    );
                                                  } else {
                                                    newSelectedOptions = [
                                                      ...selectedCellOption,
                                                      option,
                                                    ];
                                                  }
                                                  setSelectedCellOption(newSelectedOptions);
                                                  setFieldValue('cellid', newSelectedOptions || []);
                                                }}
                                              />
                                            }
                                            label={
                                              option?.countryDetails?.countryTitle +
                                              ' - ' +
                                              option?.cellTitle
                                            }
                                          />
                                        </>
                                      )}
                                    </React.Fragment>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      name="cellid"
                                      variant="outlined"
                                      placeholder={
                                        selectedCellOption.length > 1 &&
                                        selectedCellOption.length <= cellListForFilter.length
                                          ? 'Multiple Cells'
                                          : selectedCellOption.length == 1
                                          ? selectedCellOption[0].cellTitle
                                          : 'Select Cell'
                                      }
                                    />
                                  )}
                                  popupIcon={<ExpandMoreIcon />}
                                />
                              </Grid>
                              <Grid item>
                                <Button
                                  type="submit"
                                  className={classes.button}
                                  variant="outlined"
                                  onClick={async () => {
                                    setIsApplyClicked(true);
                                    const response = await loadCollectionDataFromImportForSelectedCell(
                                      selectedCellOption,
                                    );
                                    if (response) {
                                      const cellIds = selectedCellOption
                                        .filter((item) => item.id !== null && item.id !== undefined)
                                        .map((item) => item.id)
                                        .join(',');
                                      setSelectedCells(cellIds);
                                    } else {
                                      setCollectionDataFromImport([]);
                                      const cellIds = selectedCellOption
                                        .filter(
                                          (item) => item.qbId !== null && item.qbId !== undefined,
                                        )
                                        .map((item) => item.qbId)
                                        .join(',');
                                      const pastDueTableArr = await pastDueTableByCell({
                                        cellId: cellIds,
                                      });
                                      fillPastDueTotals(pastDueTableArr?.reportResult);
                                    }
                                  }}
                                >
                                  Apply
                                </Button>
                                {isSubmitting && (
                                  <CircularProgress size={24} className={classes.buttonProgress} />
                                )}
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="text"
                                  className={classes.clearbtn}
                                  onClick={async () => {
                                    resetForm();
                                    setSelectedCountryOption([]);
                                    setSelectedCellOption([]);
                                    setSelectedCells(null);

                                    // Clear all table data immediately
                                    setPastDueTableObject([]);
                                    setCollectionDataFromImport([]);
                                    setDisplayedTcData([]);
                                    setIsDataFromImport(false);
                                    setTotalOverallOutstandingBalance(0);
                                    setTotalPastDueBalance(0);
                                    seTtotalAccountReceivables(0);

                                    // Load data with empty selection (pass empty array directly)
                                    const data = await loadCollectionDataFromImportForSelectedCell(
                                      [],
                                    );
                                    if (!data) {
                                      loadPastDueTableByCountry();
                                    }
                                  }}
                                >
                                  Clear
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                }}
              </Formik>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box m={1} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className={clsx(classes.innercontentWhite)}>
                <Box>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Box>
                      <Typography
                        variant="h5"
                        noWrap
                        className={classes.CollectionsReportSectionHeading}
                      >
                        Past Due Balance
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    {collectionReportLoader ? (
                      addLoader(10)
                    ) : (
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {isDataFromImport
                          ? formatToCurrencyDash(totalPastDueBalance)
                          : formatToCurrencyDash(pastDueTableObject?.pastDueBalance) || 'N/A'}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className={clsx(classes.innercontentWhite)}>
                <Box>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Box>
                      <Typography
                        variant="h5"
                        noWrap
                        className={classes.CollectionsReportSectionHeading}
                      >
                        Account Receivables
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    {collectionReportLoader ? (
                      addLoader(10)
                    ) : (
                      <Typography
                        variant="h2"
                        noWrap
                        className={classes.CollectionsReportGreenText}
                      >
                        {isDataFromImport
                          ? formatToCurrencyDash(totalAccountReceivables)
                          : formatToCurrencyDash(pastDueTableObject?.accountReceivable) || 'N/A'}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className={clsx(classes.innercontentWhite)}>
                <Box>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Box>
                      <Typography
                        variant="h5"
                        noWrap
                        className={classes.CollectionsReportSectionHeading}
                      >
                        Overall Outstanding Balance
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    {collectionReportLoader ? (
                      addLoader(10)
                    ) : (
                      <Typography
                        variant="h2"
                        noWrap
                        className={classes.CollectionsReportBlackText}
                      >
                        {isDataFromImport
                          ? formatToCurrencyDash(totalOverallOutstandingBalance)
                          : formatToCurrencyDash(pastDueTableObject?.overallOutstandingBalance) ||
                            'N/A'}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} className={classes.TableTotalUIAll}>
              <Box
                className={clsx(classes.innercontentWhite, classes.CollectionsReportTableMobile)}
              >
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h5" noWrap></Typography>
                  <InfoPopover
                    dashboardComments={dashboardComments}
                    dashboardSectionText="All Cells Collections Report"
                    onCommentUpdate={onCommentUpdate}
                  />
                </Box>
                <If condition={displayedTcData?.length > 0}>
                  <MaterialTable
                    style={{
                      boxShadow: 'none',
                      height: '500px',
                      overflowY: 'auto',
                      overflowX: 'auto',
                    }}
                    className={clsx(classes.materialDT, classes.CollectionsReportTableMobile)}
                    isLoading={collectionReportLoader}
                    options={{
                      toolbar: false,
                      draggable: false,
                      paging: true,
                      sorting: true,
                      pageSize: 20,
                      pageSizeOptions: [10, 20, 50, 100, 150, 200],
                      showTextRowsSelected: false,
                      toolbarButtonAlignment: 'right',
                      showFirstLastPageButtons: false,
                      actionsColumnIndex: -100,
                      emptyRowsWhenPaging: false,
                      headerStyle: {
                        position: 'sticky',
                        top: 0,
                        backgroundColor: '#f5f5f5',
                        fontWeight: 'bold',
                        zIndex: 2,
                        minWidth: '120px',
                      },
                    }}
                    localization={{
                      pagination: {
                        labelRowsSelect: 'Rows',
                        labelRowsPerPage: 'Rows Per Page',
                      },
                    }}
                    title="Collections Report"
                    columns={[
                      {
                        title: (
                          <span
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <span>Client</span>
                            <span style={{ display: 'flex', minWidth: 'auto' }}>
                              <img
                                src={
                                  show
                                    ? require('../../../../assets/images/ExpandFilled.svg').default
                                    : require('../../../../assets/images/CollapseFilled.png')
                                        .default
                                }
                                onClick={() => handleColumnClick({ field: 'client' })}
                              />
                            </span>
                          </span>
                        ),
                        field: 'client',
                        render: (data) => toProperCase(data.client),
                        sorting: false,
                        /* cellStyle: () => {
                            return show
                              ? {
                                  maxWidth: '200px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }
                              : {};
                          }, */
                        cellStyle: () => ({
                          ...(show
                            ? {
                                maxWidth: '200px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }
                            : {}),
                          ...{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: '#ffffff',
                            zIndex: 1,
                          },
                        }),
                      },
                      {
                        title: <span>Current</span>,
                        field: 'current',
                        render: (data) => formatToCurrencyDash(data.current, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '100px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '100px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            0-15 days
                          </span>
                        ),
                        field: 'zerotofifteendays',
                        render: (data) => formatToCurrencyDash(data.zerotofifteendays, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '110px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '110px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            16-30 days
                          </span>
                        ),
                        field: 'sixteentothirtydays',
                        render: (data) => formatToCurrencyDash(data.sixteentothirtydays, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '110px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '110px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            31-45 days
                          </span>
                        ),
                        field: 'thirtyonetofortyfivedays',
                        render: (data) =>
                          formatToCurrencyDash(data.thirtyonetofortyfivedays, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '110px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '110px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            46-60 days
                          </span>
                        ),
                        field: 'fortysixtosixtydays',
                        render: (data) => formatToCurrencyDash(data.fortysixtosixtydays, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '110px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '110px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            61-75 days
                          </span>
                        ),
                        field: 'sixtyonetoseventyfivedays',
                        render: (data) =>
                          formatToCurrencyDash(data.sixtyonetoseventyfivedays, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '110px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '110px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            76-90 days
                          </span>
                        ),
                        field: 'seventysixtonintydays',
                        render: (data) => formatToCurrencyDash(data.seventysixtonintydays, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '110px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '110px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            &lt;91
                          </span>
                        ),
                        field: 'morethannintyonedays',
                        render: (data) => formatToCurrencyDash(data.morethannintyonedays, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '110px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '110px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            Balance
                          </span>
                        ),
                        field: 'pastduebalance',
                        render: (data) => formatToCurrencyDash(data.pastduebalance, classes),
                        sorting: false,
                        cellStyle: {
                          minWidth: '120px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '120px',
                        },
                      },
                      {
                        title: (
                          <span>
                            Overall <br />
                            Outstanding
                          </span>
                        ),
                        field: 'overalloutstanding',
                        render: (data) => formatToCurrencyDash(data.overalloutstanding, classes),
                        sorting: true,
                        customSort: (a, b) => customSortHelper1(a, b, 'overalloutstanding'),
                        cellStyle: {
                          minWidth: '120px',
                          whiteSpace: 'nowrap',
                        },
                        headerStyle: {
                          minWidth: '120px',
                        },
                      },
                    ]}
                    data={
                      ({
                        client: 'N/A',
                        zerotofifteendays: '',
                        sixteentothirtydays: '',
                        thirtyonetofortyfivedays: '',
                        fortysixtosixtydays: '',
                        sixtyonetoseventyfivedays: '',
                        seventysixtonintydays: '',
                        morethannintyonedays: '',
                        pastduebalance: '',
                        overalloutstanding: '',
                      },
                      displayedTcData || [])
                    }
                  />
                </If>

                <If condition={displayedTcData?.length == 0 && isApplyClicked}>
                  {selectedCountryOption?.length == 0 ? (
                    'Please select country to start.'
                  ) : (
                    <>
                      Hmmm... Sorry, past due details are not available for{' '}
                      {selectedCountryOption.map((country) => country.countryTitle).join(', ')}{' '}
                      {selectedCellOption?.length > 0 && '- '}
                      {selectedCellOption?.length > 0 &&
                        selectedCellOption.map((cell) => cell.cellTitle).join(', ')}
                      , please try different options.
                    </>
                  )}
                </If>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CollectionReportAll;
